import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { observer } from 'mobx-react';
import React from 'react';
import MembershipOptionsMemrev from 'components/membership/membership_options_memrev';
import eventParamsHelper from 'utils/event_params_helper';

const Wrapper = styled.div`
  @media (min-width: 700px) {
    margin: -10px 0 0 0;
  }
  `;

@observer
class MembershipChange extends React.Component {

  get mode() {
    return AppUI.routeStore.queryParam('mode');
  }

  componentDidMount() {
    if (AppUI.siteIsMemrev) {
      AppUI.createEvent('memrev - view memberships', eventParamsHelper({ mode: this.mode }));
    }
  }

  render() {
    return (
      <Wrapper>
        {
          AppUI.siteIsMemrev &&
            <MembershipOptionsMemrev mode={this.mode} />
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(MembershipChange);
